// Parent-company footer: Candia.AI logo, "a Candia.AI company", admin contact and the app version.
export const COMPANY_EMAIL = "admin@candia.ai";
const LOGO_SRC = (process.env.PUBLIC_URL || "") + "/candia-ai-logo.png";

export default function CompanyFooter({ version, compact }) {
  const OSCAR = (process.env.PUBLIC_URL || "") + "/round_logo.png";
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6, padding: compact ? "10px 0 2px" : "18px 0 6px", textAlign: "center" }}>
      <img src={OSCAR} alt="Oscar Radar" width={compact ? 40 : 48} height={compact ? 40 : 48} style={{ borderRadius: "50%", display: "block", boxShadow: "0 4px 14px rgba(0,0,0,.45)" }} />
      <div style={{ fontSize: 10, fontWeight: 800, letterSpacing: 1.6, color: "rgba(255,255,255,0.6)" }}>OSCAR RADAR&trade; <span style={{ color: "#E2C27C" }}>v{version}</span></div>
      <div style={{ display: "flex", alignItems: "center", gap: 7, marginTop: 2 }}>
        <img src={LOGO_SRC} alt="Candia.AI" width={20} height={20} style={{ borderRadius: "50%", display: "block" }} />
        <span style={{ fontSize: 10, letterSpacing: 1, color: "rgba(255,255,255,0.45)" }}>A Candia.AI company</span>
      </div>
      <a href={"mailto:" + COMPANY_EMAIL} style={{ fontSize: 11, fontWeight: 600, color: "#C6A15B", textDecoration: "none", padding: "6px 10px", minHeight: 32, display: "inline-flex", alignItems: "center" }}>{COMPANY_EMAIL}</a>
      <div style={{ fontSize: 9, letterSpacing: 1, color: "rgba(255,255,255,0.25)" }}>&copy; 2026 Candia.AI</div>
    </div>
  );
}
